import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { AuthService } from '../../core/auth/auth.service';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-prevent-duplicate-login',
  standalone: true,
  imports: [TranslocoModule],
  templateUrl: './prevent-duplicate-login.component.html',
  styleUrl: './prevent-duplicate-login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreventDuplicateLoginComponent {
  public userEmail: string | undefined;
  constructor(private authService: AuthService, private cd: ChangeDetectorRef) {
    this.userEmail = this.authService.userEmail;
    this.cd.markForCheck();
  }

  public onClickBack(): void {
    // 프로덕션 환경에서는 sid.zammy.ai를 그대로 사용
    window.location.href = this.authService.redirectUrl;
  }
}
